// extracted by mini-css-extract-plugin
export var sbShowMain = "modal-module--sb-show-main--222QZ";
export var autoModal = "modal-module--autoModal--24bzz";
export var modal = "modal-module--modal--2wNKO";
export var content = "modal-module--content--m6Hve";
export var closeButton = "modal-module--closeButton--2TLIk";